import 'vuetify/styles'

import { createVuetify, type ThemeDefinition } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

/**
 * Brand palette: indigo primary with a teal secondary. Chosen for contrast on phones in
 * bright rooms and on laptop screens; text colors meet WCAG AA against their surfaces.
 */
const light: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#f6f6fb',
    surface: '#ffffff',
    'surface-variant': '#eef0fb',
    'on-surface-variant': '#3f3f5a',
    primary: '#4f46e5',
    'primary-darken-1': '#4338ca',
    secondary: '#0d9488',
    accent: '#7c3aed',
    error: '#dc2626',
    info: '#2563eb',
    success: '#059669',
    warning: '#b45309',
  },
  variables: {
    'border-color': '#1e1b4b',
    'border-opacity': 0.1,
    'high-emphasis-opacity': 0.92,
    'medium-emphasis-opacity': 0.68,
  },
}

const dark: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#0d0d18',
    surface: '#161626',
    'surface-variant': '#23233a',
    'on-surface-variant': '#c7c7e0',
    primary: '#818cf8',
    'primary-darken-1': '#6366f1',
    secondary: '#2dd4bf',
    accent: '#a78bfa',
    error: '#f87171',
    info: '#60a5fa',
    success: '#34d399',
    warning: '#fbbf24',
  },
  variables: {
    'border-color': '#e0e7ff',
    'border-opacity': 0.12,
  },
}

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'system',
    themes: { light, dark },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    global: { ripple: true },
    VCard: { rounded: 'xl', elevation: 0, border: true },
    VBtn: { rounded: 'lg', class: 'text-none font-weight-semibold', elevation: 0 },
    VTextField: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VTextarea: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VSelect: { variant: 'outlined', density: 'comfortable', color: 'primary' },
    VCheckbox: { color: 'primary', density: 'comfortable', hideDetails: 'auto' },
    VRadioGroup: { color: 'primary', hideDetails: 'auto' },
    VSwitch: { color: 'primary', density: 'comfortable', hideDetails: true },
    VChip: { rounded: 'lg' },
    VAlert: { rounded: 'lg', variant: 'tonal' },
    VDialog: { maxWidth: 560 },
    VTooltip: { location: 'top' },
  },
})
